import { createContext, useContext } from 'react'

export const WorkspaceVisibilityContext = createContext({ labels: true, demand: true })
export const useWorkspaceVisibility = () => useContext(WorkspaceVisibilityContext)
